// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {Configuration as MsalConfiguration, LogLevel} from "@azure/msal-browser";

export const environment = {
    production: true,
    msalClientId: 'a3ce15db-0df8-466f-994d-4324aef83630',
    adminDomain: 'onmicrosoft.com',
    msalConfig: {
        auth: {
            clientId: 'a3ce15db-0df8-466f-994d-4324aef83630',
            redirectUri: '/auth',
            authority: 'https://login.microsoftonline.com/common',
            clientCapabilities: ['CP1'],
            postLogoutRedirectUri: '/'
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback(logLevel: LogLevel, message: string) {
                    console.log(message);
                },
                logLevel: LogLevel.Warning,
                piiLoggingEnabled: true,
            }
        }
    } as MsalConfiguration,
    apiConfig: {
        uri: 'https://teamtransfer-api-dev.azurewebsites.net',
        scopes: ['a3ce15db-0df8-466f-994d-4324aef83630/.default']
    }
};
